import { Box } from "@mui/material";
import React from "react";

const Footer = () => {
  const currentyear = () => {
    let newDate = new Date();
    let year = newDate.getFullYear();

    return year;
  };

  return (
    <Box
      width="100%"
      marginTop="auto"
      marginLeft="auto"
      marginRight="auto"
      paddingBottom="30px"
      paddingTop="30px"
      fontWeight="400"
      fontSize="14px"
      lineHeight="22px"
      textAlign="center"
      bottom="0"
      sx={{
        cursor: "default",
      }}
      // className="foot-w2"
    >
      © {currentyear()} Deepangshi Saha - Software Engineer
      {/* <br /> All Rights Reserved. */}
      {/* All Rights Reserved. <br />
       Built with{" "}
      <span
        style={{
          color: "#d4af37",
        }}
        className="heart-f"
      >
        ♡{" "}
      </span>
      by DS. */}
    </Box>
  );
};

export default Footer;
